import axios from '../../utils/axios';
import CRUD from './crud'

const participantPrices = new CRUD('participant-prices', 'superior-judge')

export default Object.assign(
    participantPrices,
    {
        reducers: {
            ...participantPrices.reducers
        },


    }
)
